import Vue from 'vue';

Vue.component('PageHeader', () => import('./PageHeader'));